module.exports = __webpack_public_path__ + "img/chat_b.25a65420.svg";